/**
 * Format `count / denom` as a percentage label that never misleads at the
 * extremes: a share that is not actually complete never rounds up to "100%",
 * and a non-zero share never collapses to "0%". Used by the credential funnel
 * and the page subtitle so both read the 99.98% / <0.1% edges consistently.
 */
export function formatShare(count: number, denom: number): string {
  if (count <= 0 || denom <= 0) return "0%";
  if (count >= denom) return "100%";
  const pct = (count / denom) * 100;
  if (pct > 99.99) return ">99.99%";
  if (pct >= 99) return `${pct.toFixed(2)}%`;
  if (pct < 0.1) return "<0.1%";
  if (pct < 10) return `${pct.toFixed(1)}%`;
  return `${Math.round(pct)}%`;
}
